import React, { useState } from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";

export default function SummaryCard({ totalBalance, currency }) {
  const history = useHistory();
  const [transformStyle, setTransformStyle] = useState({});
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseMove = (e) => {
    const card = e.currentTarget.getBoundingClientRect();
    const xAxis = (e.clientX - card.left - card.width / 2) / 10; // Calculate tilt on X-axis
    const yAxis = -(e.clientY - card.top - card.height / 2) / 10; // Calculate tilt on Y-axis
    setTransformStyle({
      transform: `rotateY(${xAxis}deg) rotateX(${yAxis}deg) scale(1.1)`, // Scale for lift effect
    });
  };

  const handleMouseEnter = () => {
    setIsHovered(true); // Enable hover effect
    setTransformStyle({
      transform: `scale(1.1)`, // Lift effect on hover
      transition: "transform 0.1s ease-in", // Smooth transition when
    });
  };

  const handleMouseLeave = () => {
    setIsHovered(false); // Disable hover effect
    setTransformStyle({
      transform: `rotateY(0deg) rotateX(0deg) scale(1)`, // Reset to original
      transition: "transform 0.5s ease-out", // Smooth transition back to normal
    });
  };

  return (
    <div
      className="relative flex flex-col min-w-0 break-words bg-white rounded mb-4 shadow-lg w-full h-full"
      onClick={() => history.push("/expenses")}
      onMouseMove={isHovered ? handleMouseMove : null} // Only track movement if hovered
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{
        cursor: "pointer",
        // maxWidth: "300px",
        ...transformStyle, // Apply dynamic transform styles
        transition: isHovered
          ? "transform 0.1s ease"
          : "transform 0.5s ease-out", // Smooth transitions
        perspective: "1000px", // 3D perspective for tilt effect
      }}
    >
      <div className="">
        <div className="">
          <div className="relative w-full pr-2 max-w-full flex-grow flex-1">
            <h2
              className="text-xl font-semibold text-center mt-3"
              style={{
                fontWeight: "bold !important",
              }}
            >
              Expense Management
            </h2>
            <div className="text-sm" style={{ marginTop: "50px" }}>
              <div className="mb-1">
                Available Balance ({currency}) : <br />
                <span className="text-emerald-500 font-semibold">
                  {totalBalance?.availableBalance ?? 0}
                </span>
              </div>
              <div className="mb-1">
                Total Credited ({currency}) : <br />
                <span className="text-orange-500 font-semibold">
                  {totalBalance?.totalCreatedSum}
                </span>
              </div>
              <div>
                Total Debited ({currency}) : <br />
                <span className="text-red-500 font-semibold">
                  {totalBalance?.totalDebitedSum}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

SummaryCard.propTypes = {
  totalBalance: PropTypes.shape({
    availableBalance: PropTypes.number,
    totalCreatedSum: PropTypes.number,
    totalDebitedSum: PropTypes.number,
  }).isRequired,
  currency: PropTypes.string.isRequired,
};
